export const getLayerPropertyByKey = ({
  key,
  properties,
}: {
  key: any;
  properties: any;
}) => {
  if (!key) {
    return null;
  }

  const property = properties.find((prt: any) => prt.key === key);

  if (!property) {
    return null;
  }

  return property;
};
